import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import {  useNavigate, useParams } from 'react-router-dom'
import { useGetTasksQuery } from './tasksApiSlice'
import { memo } from 'react'
import useAuth from "../../hooks/useAuth"
import TimeLeft from '../../partial/TimeLeft'
import ReactQuill from 'react-quill';

const Task = ({ taskId, selected, setSelected }) => {
    const {groupId, type} = useParams()
    const { isTeacher, isAdmin, isStudent } = useAuth()




    const { task } = useGetTasksQuery("tasksList", {
        selectFromResult: ({ data }) => ({
            task: data?.entities[taskId]
        }),
    })

    const navigate = useNavigate()
    const changeSelected = (checked, taskId) =>{
        if(checked)
            setSelected([...selected, taskId])
        else
        setSelected([...selected.filter(t=> t!= taskId)])
    }

    if (task) {
        //const created = new Date(task.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })
         const handleView = () => navigate(`/${type}/${groupId}/tasks/${taskId}/actions`)
         const handleEdit = () => navigate(`/${type}/${groupId}/tasks/${taskId}`)
         const cellStatus = task.active ? '' : 'table__cell--inactive'

         let editButton = null
         if(isAdmin|| isTeacher){editButton=(<>
             <button
             className="icon-button table__button"
             onClick={handleEdit}
         >
             <FontAwesomeIcon icon={faPenToSquare} />
         </button>
          <input checked={selected.includes(task._id)}  className="form__checkbox" id={`cb_${task._id}`} onChange={(e)=>changeSelected(e.target.checked,task._id)} type="checkbox" /><label htmlFor={`cb_${task._id}`} ></label>
         
          </>
         )}
         
   
  
        return (
            <tr className="table__row">
                <td className={`table__cell task__title ${cellStatus}`}>{task.title} <span className='small-text'>{task.groupname}</span> </td>
                <td className={`table__cell task__body quill-max-height-250  ${cellStatus}`}   >
                    {/* <div className='ql-editor'  dangerouslySetInnerHTML={{__html: task.body}}></div> */}
                    {/* <ReactQuill
                     theme='bubble'
                    readOnly
                    value={ task.body}
                    
                    ></ReactQuill>*/}
                   </td>
                <td className={`table__cell task__dates ${cellStatus}`} > <TimeLeft endtime={task.toDate} /> </td>
                <td className={`table__cell task_student task__done ${cellStatus}`} > <span className={`action__status--${task.doneActions < task.numActions?'open':'completed'}`}>{task.doneActions} מתוך {task.numActions}</span></td>
                <td className={`table__cell task_student task__dates ${cellStatus}`} >{task.gradeActions}  מתוך {task.numActions}</td>
                <td className={`table__cell  ${cellStatus}`} >{task.ratio? `${task.ratio}%`:'auto' }</td>
                <td className={`table__cell task__actions ${cellStatus}`} >{task.numActions}</td>
          

                <td className={`table__cell task_p ${cellStatus}`}>
                   
                   {isStudent && <button
                        className=" table__button"
                        onClick={handleView}
                    >
                      הגשה   <FontAwesomeIcon icon={faEye} />
                    </button>
    }
                    {editButton}
               
                  
                </td>
            </tr>
        )

    } else return null
}

const memoizedTask = memo(Task)

export default memoizedTask